export const DELIVERY_DAY_ERROR =
  'Selected date is not on an allowed delivery day for this school';

export const USER_DELIVERY_DAYS_PAYLOAD = [
  { DayId: 'saturday' },
  { DayId: 'sunday' },
  { DayId: 'monday' },
  { DayId: 'tuesday' },
  { DayId: 'wednesday' },
  { DayId: 'thursday' },
  { DayId: 'friday' },
];

export function toUserDeliveryDaysPayload(selectedDayIds) {
  return USER_DELIVERY_DAYS_PAYLOAD.filter(
    (day) => selectedDayIds && selectedDayIds.includes(day.DayId),
  );
}

export function hasUserDeliveryDays(user) {
  return Array.isArray(user?.UserDeliveryDays) && user.UserDeliveryDays.length > 0;
}

export function getEffectiveDeliveryDays(school, district) {
  if (hasUserDeliveryDays(school)) {
    return school.UserDeliveryDays;
  }
  return district?.UserDeliveryDays;
}

export function getDeliveryDayId(date) {
  if (!date || typeof date.format !== 'function') return null;
  return date.format('dddd').toLowerCase();
}

export function isDateOnDeliveryDays(date, deliveryDays) {
  const dayId = getDeliveryDayId(date);
  if (!dayId || !Array.isArray(deliveryDays)) return false;
  return deliveryDays.map((day) => day.DayId).includes(dayId);
}

export function isAllowedDeliveryDate(date, school, district) {
  const days = getEffectiveDeliveryDays(school, district);
  return Boolean(days && isDateOnDeliveryDays(date, days));
}

export function getDeliveryDayValidationError(date, school, district) {
  if (!date) return null;
  if (isAllowedDeliveryDate(date, school, district)) return null;
  return DELIVERY_DAY_ERROR;
}
